import { render, staticRenderFns } from "./AlertModel.vue?vue&type=template&id=e3c45c20"
import script from "./AlertModel.vue?vue&type=script&lang=ts"
export * from "./AlertModel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3c45c20')) {
      api.createRecord('e3c45c20', component.options)
    } else {
      api.reload('e3c45c20', component.options)
    }
    module.hot.accept("./AlertModel.vue?vue&type=template&id=e3c45c20", function () {
      api.rerender('e3c45c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alert/AlertModel.vue"
export default component.exports